import { render, staticRenderFns } from "./Orderinstallinfo.vue?vue&type=template&id=6869b631&scoped=true&"
import script from "./Orderinstallinfo.vue?vue&type=script&lang=js&"
export * from "./Orderinstallinfo.vue?vue&type=script&lang=js&"
import style0 from "./Orderinstallinfo.vue?vue&type=style&index=0&id=6869b631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6869b631",
  null
  
)

export default component.exports